import React, { useState, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import { auth } from "../../firebase";
import {
  Typography,
  TextField,
  Button,
  Paper,
  Container,
  Box,
  Grid,
  Snackbar,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import AccountContext from "../../contexts/AccountContext";

const useStyles = makeStyles((theme) => ({
  portada: {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: (colors) => colors.navbarBackground || "rgba(2,2,2,1)",
    width: "100vw",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(10),
    [theme.breakpoints.down("sm")]: {
      gap: theme.spacing(5),
    },
  },
  topbar: {
    color: (colors) => colors.navbarText || "rgb(204, 170, 102) !important",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    paddingTop: theme.spacing(5),
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    alignItems: "center",
    textAlign: "center !important",
    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
    },
  },
  barTitle: {
    [theme.breakpoints.down("xs")]: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
    },
  },
  centeredPanel: {
    margin: "0 auto",
    "& a": {
      color: (colors) => colors.navbarText || "rgb(204, 170, 102) !important",
      textDecoration: "none",
    },
  },
  paper: {
    padding: theme.spacing(5),
    borderRadius: 10,
    marginBottom: theme.spacing(3),
    width: "90vw",
    maxWidth: 450, // Reduced from 700px to 450px
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(3),
      width: "85vw", // Slightly narrower on small screens
    },
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  icon: {
    marginBottom: theme.spacing(2),
    fontSize: 40,
    color: theme.palette.primary.main,
  },
  error: {
    color: theme.palette.error.main,
    marginTop: theme.spacing(2),
    textAlign: "center",
  },
}));

const PasswordForgetPage = () => {
  const account = useContext(AccountContext);
  const classes = useStyles(account?.colors || {});
  const history = useHistory();

  return (
    <div className={classes.portada}>
      <div className={classes.topbar}>
        <Typography variant="h6" color="inherit" className={classes.barTitle}>
          Tu música en Spotify, Apple Music, Amazon y más...
        </Typography>

        <Button
          className={classes.loginButton}
          color="inherit"
          variant="contained"
          component={Link}
          to="/signin"
        >
          ENTRAR
        </Button>
      </div>

      <div className={classes.centeredPanel}>
        <Paper elevation={1} className={classes.paper}>
          <PasswordForgetForm classes={classes} />
        </Paper>

        <Typography align="center">
          <Link to="/signin">Ya tengo una cuenta</Link>
        </Typography>
      </div>
    </div>
  );
};

const PasswordForgetForm = ({ classes }) => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const onSubmit = (event) => {
    event.preventDefault();

    auth
      .doPasswordReset(email)
      .then(() => {
        setEmail("");
        setError(null);
        setSuccess(true);
      })
      .catch((error) => {
        setError(error);
      });
  };

  const isInvalid = email === "";

  return (
    <>
      <Typography component="h1" variant="h5" align="center" gutterBottom>
        Recuperar contraseña
      </Typography>

      <form className={classes.form} onSubmit={onSubmit}>
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="email"
          label="Correo electrónico"
          name="email"
          autoComplete="email"
          autoFocus
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          className={classes.submit}
          disabled={isInvalid}
        >
          Enviar
        </Button>
      </form>

      {error && (
        <Typography className={classes.error} variant="body2">
          {error.message}
        </Typography>
      )}

      <Snackbar
        open={success}
        autoHideDuration={6000}
        onClose={() => setSuccess(false)}
        message="Se ha enviado un correo de recuperación. Por favor revisa tu bandeja de entrada."
      />
    </>
  );
};

const PasswordForgetLink = () => (
  <Typography align="center" variant="body2">
    <Link to="/pw-forget">¿Olvidaste tu contraseña?</Link>
  </Typography>
);

export default PasswordForgetPage;

export { PasswordForgetForm, PasswordForgetLink };
